const mesesSugestaoDoencasGravesList = [
      {
         id: 0,
         descricao: '0 meses',
         ordem: 0,
      },
      {
         id: 12,
         descricao: '12 meses',
         ordem: 12,
      },
      {
         id: 18,
         descricao: '18 meses',
         ordem: 18,
      },
      {
         id: 24,
         descricao: '24 meses',
         ordem: 24,
      },
      {
         id: 36,
         descricao: '36 meses',
         ordem: 36,
      },
      {
         id: 48,
         descricao: '48 meses',
         ordem: 48,
      },
      {
         id: 60,
         descricao: '60 meses',
         ordem: 60,
      },
 ]
 
 export default mesesSugestaoDoencasGravesList